import { defineMessages, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Button from '../Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFile,
  faFileAudio,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFileVideo,
  faFileWord,
  faFileZipper,
} from '@fortawesome/free-solid-svg-icons';

const messages = defineMessages({
  download: {
    id: 'Download',
    defaultMessage: 'Download',
  },
});

const mimeTypeToIcon = {
  pdf: faFilePdf,
  doc: faFileWord,
  docx: faFileWord,
  xls: faFileExcel,
  xlsx: faFileExcel,
  csv: faFileCsv,
  txt: faFile,
  rtf: faFile,
  odt: faFileWord,
  ods: faFileExcel,
  'vnd.oasis.opendocument.spreadsheet': faFileExcel,
  ppt: faFile,
  pptx: faFile,
  jpg: faFileImage,
  jpeg: faFileImage,
  png: faFileImage,
  gif: faFileImage,
  bmp: faFileImage,
  tiff: faFileImage,
  svg: faFileImage,
  mp3: faFileAudio,
  wav: faFileAudio,
  ogg: faFileAudio,
  mp4: faFileAudio,
  avi: faFileAudio,
  mov: faFileAudio,
  wmv: faFileAudio,
  flv: faFileAudio,
  mkv: faFileAudio,
  zip: faFileZipper,
  rar: faFileZipper,
  tar: faFileZipper,
  gz: faFileZipper,
  '7z': faFileZipper,
  webm: faFileVideo,
  mpeg: faFileVideo,
  mpg: faFileVideo,
  m4v: faFileVideo,
  '3gp': faFileVideo,
  '3g2': faFileVideo,
};

const DownloadFile = ({ item, intl, isEditMode = false }) => {
  const downloadUrl = !isEditMode
    ? `${item.getURL}/@@download/file`
    : undefined;

  const mimeTypeParts = item.mime_type?.split('/');
  const fileExtension = mimeTypeParts
    ? mimeTypeParts[mimeTypeParts.length - 1]
    : '';
  const icon = mimeTypeToIcon[fileExtension] || faFile;

  return (
    <div className="download-file">
      <div className="df-section">
        <FontAwesomeIcon icon={icon} />
        <span className="df-title">{item.title}</span>
      </div>
      <div className="df-section right">
        {item.getObjSize && <span className="df-size">{item.getObjSize}</span>}
        <Button
          label={intl.formatMessage(messages.download)}
          variation="secondary"
          href={downloadUrl}
        />
      </div>
    </div>
  );
};

DownloadFile.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    getObjSize: PropTypes.string,
    getURL: PropTypes.string,
    mime_type: PropTypes.string,
  }),
  isEditMode: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(DownloadFile);
